import { ConsumerRoutes } from 'src/shared/Routes';

export const SHORT_LINKS: Record<string, string> = {
  '/payments': ConsumerRoutes.CONSUMER_ACCOUNT_PAYMENT_METHODS,
};

export const SHORT_LINK_PATHS = Object.keys(SHORT_LINKS);

export const resolveShortLink = (pathname: string): string | undefined =>
  SHORT_LINKS[pathname.toLowerCase().replace(/\/+$/, '')];
